class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem("storedDiscount")) {
      this.querySelector('input[name="discount"]').value =
        localStorage.getItem("storedDiscount");
    }
    this.querySelector("[data-update-coupon]").addEventListener(
      "click",
      (event) => {
        $(this.querySelector("[data-update-coupon]")).addClass("is-loading");
        this.val = this.querySelector('input[name="discount"]').value;
        if (this.val == "") {
          localStorage.setItem("storedDiscount", "");
          this.val = 0;
        } else {
          localStorage.setItem("storedDiscount", this.val);
        }
        fetch(`/discount/${this.val}`).then((response) => {
          fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
          }).then((response) => {
            window.location.reload();
          });
        });
      }
    );
  }
}

customElements.define("coupon-code-cart", CouponCode);
